{
  "channels": "Channels",
  "rules": "Rules",
  "deliveries": "What was sent",
  "lastFifty": "last 50",
  "addChannel": "Add a channel",
  "addRule": "Add a rule",
  "channelFirst": "Create a channel first: a rule needs somewhere to write to",
  "channelOn": "{{name}}: enabled",
  "channelOff": "{{name}}: disabled",
  "ruleOn": "{{name}}: enabled",
  "ruleOff": "{{name}}: disabled",
  "secretSet": "set",
  "secretMissing": "none",
  "testAria": "Test {{name}}",
  "testTitle": "Send a test message",
  "testSent": "The test message went out. If it did not arrive, check the recipient address rather than the channel.",
  "testFailed": "The test message did not arrive",
  "testFailedHint": "{{reason}}. Fix the channel settings and test again.",
  "unknownReason": "the reason is unknown",
  "editAria": "Edit {{name}}",
  "deleteAria": "Delete {{name}}",
  "editChannel": "Edit the channel",
  "deleteChannel": "Delete the channel together with its rules",
  "editRule": "Edit the rule",
  "deleteRule": "Delete the rule",
  "channelsFailed": "The channel list is unavailable",
  "deleteChannelFailed": "Deleting the channel failed",
  "rulesFailed": "The rule list is unavailable",
  "logFailed": "The log is unavailable",
  "saveFailed": "Saving failed",
  "noChannels": "No channels yet",
  "noChannelsHint": "A channel is an address the platform writes to when something breaks: the on-call mailbox, a Telegram chat, or a webhook into another system. Start with one.",
  "noRules": "No rules yet",
  "noRulesHint": "A rule ties a condition to a channel: “any node goes down — into the on-call chat”. Without rules the channels stay silent.",
  "noDeliveries": "Nothing has been sent",
  "noDeliveriesHint": "This shows what went where — failed attempts and their reasons included. Until a rule fires, the log is empty.",
  "delivered": "delivered",
  "notDelivered": "not delivered",
  "ruleDeleted": "deleted",
  "channelDeleted": "deleted",
  "eventsHint": "events in the message · suppressed as a storm",
  "channelKind": {
    "email": "Email",
    "telegram": "Telegram",
    "webhook": "Webhook"
  },
  "status": {
    "down": "goes down",
    "up": "comes back",
    "unknown": "becomes unknown"
  },
  "column": {
    "channel": "Channel",
    "kind": "Kind",
    "target": "To",
    "secret": "Secret",
    "rule": "Rule",
    "condition": "Condition",
    "at": "When",
    "subject": "Subject",
    "events": "Events",
    "reason": "Reason"
  },
  "form": {
    "channelNameHint": "How to tell the channel apart in the rule list: “On-call chat”, “Department mailbox”",
    "ruleNameHint": "“Warehouse outages”, “Everything to the on-call”",
    "kindFixed": "The kind does not change: each has its own settings form and its own meaning for the secret. Need another one — create another channel",
    "recipients": "Recipients",
    "recipientsHint": "Comma-separated. The mail server itself is set by the SMTP_URL and SMTP_FROM variables",
    "chat": "Chat",
    "chatHint": "Chat id or @channel name. Groups are a negative number",
    "botToken": "Bot token",
    "newBotToken": "New bot token",
    "botTokenHint": "Issued by @BotFather. The bot must be added to the chat",
    "keepToken": "Empty — keep the current token",
    "urlHint": "POST with a JSON body. http and https only",
    "signingKey": "Signing key",
    "newSigningKey": "New signing key",
    "signingKeyHint": "Needed when body signing is on. Empty while editing — keep the current one",
    "channelEnabled": "Channel enabled",
    "silent": "Silent",
    "sign": "Sign the body (HMAC-SHA256)",
    "signHint": "The receiver will be able to tell our notification from a stranger's request to the same address",
    "notifyWhen": "Notify when a node",
    "noneMeansAll": "— none checked means “all”",
    "checkKinds": "Check kinds",
    "ruleEnabled": "Rule enabled",
    "noTransitions": "No transition is checked — such a rule will never fire."
  },
  "rule": {
    "nothingHappens": "nothing happens",
    "or": " or ",
    "allSites": "on every site",
    "atSites": "on sites: {{list}}",
    "deletedSite": "deleted",
    "anyCheck": "on any check",
    "checks": "on the {{list}} checks",
    "sentence": "a node {{statuses}} {{where}}, {{kinds}}"
  }
}
